import { createFileRoute } from "@tanstack/react-router";
import { EditContent, Translations } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/copy-and-translations/")({
  component: () => (
    <EditContent>
      <Translations />
    </EditContent>
  ),
});

export { Route };
